import { inputHandler } from 'utils/eventHandlers'
import request from 'utils/request'

const { REACT_APP_API_URL: API_URL } = process.env

export const initialState = {
  email: '',
  password: '',
  confirmPassword: '',
  integration: '',
  selected: JSON.parse(localStorage.getItem('selected')) || 'account'
}

const mountHandler = api => () => {
  api.props.getAccount()
  api.props.getIntegrations()
}

const receivePropsHandler = api => nextProps => {
  if (api.props.email !== nextProps.account.email) {
    api.setState({ email: nextProps.account.email })
  }
}

const clickHandler = api => integration => {
  api.setState({ integration: integration !== api.state.integration ? integration : '' })
}

const removeHandler = api => () => {
  api.props.removeIntegration({ service: api.state.integration })
}

const selectHandler = () =>
  request.post(`${API_URL}/stripe/session`, { quantity: 1 })
    .then(url => window.location.assign(url))

const submitHandler = api => e => {
  e.preventDefault()
  if (api.state.password === api.state.confirmPassword) {
    const { email, password } = api.state
    api.props.updateAccount({ email, password })
    api.setState(initialState)
  }
}

const tabHandler = api => e => {
  api.setState({ selected: e.target.name })
  localStorage.setItem('selected', JSON.stringify(e.target.name))
}

export default api => ({
  change: inputHandler(api),
  click: clickHandler(api),
  receiveProps: receivePropsHandler(api),
  mount: mountHandler(api),
  remove: removeHandler(api),
  select: selectHandler,
  submit: submitHandler(api),
  tab: tabHandler(api)
})
